<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            {{ "Add Component" | translate | async }}
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
      <form class="header-form">
        <mat-form-field class="header-form-full-width" [class.required-field]="showValidation && !ComponentType">
          <mat-label>
            {{ 'Component Type' | translate | async }}
            <span class="required-star">*</span>
          </mat-label>
          <mat-select
              name="componentType_"
              [(ngModel)]="ComponentType"
              #componentType_="ngModel"
              (selectionChange)="changeComponentType($event)">
            <mat-option *ngFor="let type of componentTypeList"
                        [value]="type.Id">
              {{ type.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <mat-form-field class="header-form-full-width">
            <mat-label>
              {{ isEqBarType ? ('Type' | translate | async) : ('Part' | translate | async) }}
              <span class="required-star">*</span>
            </mat-label>
          <mat-select [placeholder]="isEqBarType ? (('Type' | translate | async) + '*') : (('Part' | translate | async) + '*')"
                      name="compPart_" [(ngModel)]="selectedCompartId" #compPart_="ngModel"
                      (selectionChange)="changePartNumber($event)">
            <mat-option [value]="type.CompartId" [matTooltip]="type.Part_No" *ngFor="let type of compartList">
              {{type.Part_No}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field class="header-form-full-width" [class.required-field]="showValidation && !selectedCompartId">
          <mat-label>
            {{ isEqBarType ? ('Type' | translate | async) : ('Part' | translate | async) }}
            <span class="required-star">*</span>
          </mat-label>
          <mat-select
              name="compPart_"
              [(ngModel)]="selectedCompartId"
              #compPart_="ngModel"
              (selectionChange)="changePartNumber($event)">
            <mat-option
                *ngFor="let type of compartList"
                [value]="type.CompartId"
                [matTooltip]="type.Part_No">
              {{ type.Part_No }}
            </mat-option>
          </mat-select>
      </mat-form-field>
        <!-- <mat-form-field class="header-form-full-width" *ngIf="isEqBarType">
          <mat-select placeholder="{{'Condition' | translate | async}}*" name="compCondition_" [(ngModel)]="selectedConditon" #compCondition_="ngModel">
            <mat-option value="A">A</mat-option>
            <mat-option value="B">B</mat-option>
            <mat-option value="C">C</mat-option>
            <mat-option value="X">X</mat-option>
          </mat-select>
        </mat-form-field> -->
        <!-- <mat-form-field
    class="header-form-full-width"
    *ngIf="isEqBarType"
    [class.required-field]="showValidation && !selectedConditon">

  <mat-label>
    {{ 'Condition' | translate | async }}
    <span class="required-star">*</span>
  </mat-label>

  <mat-select
      name="compCondition_"
      [(ngModel)]="selectedConditon"
      #compCondition_="ngModel">

    <mat-option value="A">A</mat-option>
    <mat-option value="B">B</mat-option>
    <mat-option value="C">C</mat-option>
    <mat-option value="X">X</mat-option>

  </mat-select>

</mat-form-field> -->
        <mat-form-field class="header-form-full-width" [class.required-field]="showValidation && !SelectedMakeId">
          <mat-label>
            {{ 'Brand' | translate | async }}
            <span class="required-star">*</span>
          </mat-label>
          <mat-select [(ngModel)]="SelectedMakeId" name="make" (selectionChange)="brandSelected($event)">
            <mat-option *ngFor="let make of makeList"
                        [value]="make.Id">
              {{ make.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width"
          *ngIf="isChild && childCompoentList?.length && ComponentType != 230 && ComponentType != 231 && ComponentType != 232 && ComponentType != 236">
          <mat-select placeholder="Parent Position" [(ngModel)]="Position" name="CompPosition_" required
              (selectionChange)="onPositionSelected($event.value)">
            <mat-option *ngFor="let position of componentPositionSide" [value]="position">{{position.Pos}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="child-component-section" *ngIf="isChild && childCompoentList?.length && Position != null">
          <div class="child-component-title">
            Child Components
          </div>
          <div class="child-component-list">
            <div *ngFor="let c of childCompoentList">
              <div *ngIf="c.IsChild && c.UserSelectable !== true">
                {{ c.CompartName }}
              </div>
              <mat-checkbox *ngIf="c.UserSelectable === true || !c.IsChild" [(ngModel)]="c.IsChild" [ngModelOptions]="{ standalone: true }"
                (change)="onCheckboxChange($event, c.CompartId)">
                {{ c.CompartName }}
              </mat-checkbox>
            </div>
          </div>
        </div>

        <!-- <mat-form-field class="header-form-full-width">
          <mat-select placeholder="Brand" [(ngModel)]="SelectedMakeId" (selectionChange)="brandSelected($event)"
                      name="make">
            <mat-option *ngFor="let make of makeList" [value]="make.Id">{{make.Name}}</mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field class="header-form-full-width" *ngIf="isEqBarType">
          <input matInput type="number" placeholder="{{'Budget Life' | translate | async}}" [(ngModel)]="budgetLife" name="budgetLife">
        </mat-form-field>

        <mat-form-field class="header-form-full-width" *ngIf="isEqBarType">
          <input matInput type="number" placeholder="{{'CMU' | translate | async}}" [(ngModel)]="cmu" name="cmu">
        </mat-form-field>

        <mat-form-field class="header-form-full-width" *ngIf="isEqBarType">
          <input matInput type="number" placeholder="{{'Cost' | translate | async}}" [(ngModel)]="cost" name="cost">
        </mat-form-field>


        <div class="action-row">
          <a class="button"><span class="button__text" (click)="onNoClick()">Cancel</span></a>
          <a class="button" [ngClass]="{ 'button--primary': canSave && !isSaving, 'disabled': !canSave || isSaving}"
            (click)="canSave && !isSaving && onSave()">
            <span class="button__text" *ngIf="!isSaving">
              {{ 'Save/Update' | translate | async }}
            </span>
            <mat-spinner
                *ngIf="isSaving"
                diameter="20"
                strokeWidth="3">
            </mat-spinner>
          </a>
        </div>
      </form>
    </div>
</div>
